module.exports = __webpack_public_path__ + "img/horcrux-helga-hufflepuff.3e7d0700.png";